module.exports = __webpack_public_path__ + "img/button_mach_mit_outlined.25e1fe10.svg";